import { render, staticRenderFns } from "./AggregatePayment.vue?vue&type=template&id=96c137fc&scoped=true"
import script from "./AggregatePayment.vue?vue&type=script&lang=js"
export * from "./AggregatePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c137fc",
  null
  
)

export default component.exports